// src/core/featureRoutes.ts
import { RouteObject } from 'react-router';

// Webpack scans feature/ at BUILD TIME for all routes.tsx files
// Arguments: (directory, useSubdirectories, filePattern)
const routeModules = require.context(
    '../feature',    // relative path from this file
    true,            // search subdirectories
    /routes\.tsx$/   // match files named routes.tsx
);

// Aggregate all routes
export const FeatureRoutes: RouteObject[] = [];

routeModules.keys().forEach((modulePath: any) => {
    // modulePath looks like: "./userManagement/routes.tsx"
    const module = routeModules(modulePath);

    // Each routes.tsx exports { routes: RouteObject[] }
    if (module.routes) {
        FeatureRoutes.push(...module.routes);
    }
});
